export default __webpack_public_path__ + "/dist/images/food-list-icon.svg";